export default __webpack_public_path__ + "static/KeywordResearch_02_04@2x-20e2d20917ff0a699bcf11e6541a116d.webp";